import {HOMEPAGE_NOTICE, HomepageNotice} from "./homepage-notice";
import {environment} from "../../environments/environment";

export abstract class HomepageNoticeFetchService {

  abstract fetchHomepageNotice(): Promise<HomepageNotice | undefined>;

}

export class BrowserHomepageNoticeFetchService implements HomepageNoticeFetchService {

  fetchHomepageNotice(): Promise<HomepageNotice> {
    const url = this.buildHomepageNoticeUrl();
    return fetch(url)
      .then(r => r.json());
  }

  /**
   * Production database id is a part of the http domain, while emulator database id is passed as a query parameter.
   * This method ensures that the homepage notice URL is constructed correctly in both cases.
   */
  buildHomepageNoticeUrl() {
    const [url, optionalQueryParams] = environment.firebaseConfig.databaseURL.split('?', 2);
    const urlWithSlash = url.endsWith('/') ? url : url.concat('/');
    const queryParams = optionalQueryParams ? `?${optionalQueryParams}` : '';
    return `${urlWithSlash}${HOMEPAGE_NOTICE}.json${queryParams}`;
  }

}

export class ServerHomepageNoticeFetchService implements HomepageNoticeFetchService {

  fetchHomepageNotice(): Promise<undefined> {
    return Promise.resolve(undefined);
  }

}
